import { useEffect, useState } from 'react';
import { ItemScheme } from '../../../Components/Form/MagicFormItem';
import { HealthPlanCode } from '../../../Enums/HealthPlanCode.enum';
import apiClient from '../../../Services/ApiClient';
import { useAppContext } from '../../../Services/AppContext';
import { useHealthPlanContext } from '../../../Services/HealthPlanContext';
import { useIsLatam } from '../../Region/Services/region.service';
import HealthPlanOtherConsultationsBabyLatamForm
	from '../Components/HealthPlanOtherConsultations/HealthPlanOtherConsultationsBabyLatamForm';
import HealthPlanOtherConsultationsDiabetesLatamForm
	from '../Components/HealthPlanOtherConsultations/HealthPlanOtherConsultationsDiabetesLatamForm';
import { FormHookCountry, FormHookResult } from './FormHook.interface';
import { useHealthPlanOtherConsultationsFormScheme } from './useHealthPlanOtherConsultationsFormScheme';

const useHealthPlanOtherConsultationsForm = (): FormHookResult => {
	const { globalTemplate } = useAppContext();
	const { getFormSchemeForDiabetes } = useHealthPlanOtherConsultationsFormScheme();

	const HealthPlanOtherConsultationsForms: FormHookCountry = {
		latam: {
			meddibaby: HealthPlanOtherConsultationsBabyLatamForm,
			diabetes: getFormSchemeForDiabetes(),
		},
		// TODO Add actual forms in case country is not latam
		default: {
			meddibaby: HealthPlanOtherConsultationsBabyLatamForm,
			diabetes: HealthPlanOtherConsultationsDiabetesLatamForm,
		},
	};

	const {
		healthPlan,
		healthPlanUser,
		healthPlanData,
		activeHealthPlanUserItem,
	} = useHealthPlanContext();

	const [form, setForm] = useState<ItemScheme[]>(
		HealthPlanOtherConsultationsForms.default[
		healthPlan.code ?? HealthPlanCode.DIABETES
			],
	);
	const isLatam = useIsLatam(globalTemplate);

	useEffect(() => {
		const formScheme =
			HealthPlanOtherConsultationsForms[isLatam ? 'latam' : 'default'][
			healthPlan.code ?? HealthPlanCode.DIABETES
				];
		setForm(formScheme);
	}, [healthPlan.code, isLatam]);

	const submitValues = async (
		values: any,
		onSuccess?: () => void,
	): Promise<boolean> => {
		let medicalEvaluationFilled = false;
		const sameMonth = Object.keys(healthPlanData)
			.map(h => healthPlanData[h])
			.find(m => m.month === activeHealthPlanUserItem?.extra?.month);

		if (sameMonth) {
			const medicalEvaluation = sameMonth?.children.find(
				(k: Record<string, any>) => k.type === 'medicalEvaluation',
			);
			if (
				medicalEvaluation?.extra?.status === 'completed' ||
				medicalEvaluation?.extra?.status === 'scheduled'
			) {
				medicalEvaluationFilled = true;
			}
		}

		if (activeHealthPlanUserItem?.extra?.month != 1) {
			const firstMonth = Object.keys(healthPlanData)
				.map(h => healthPlanData[h])
				.find(m => m.month === 1);

			if (firstMonth) {
				const medicalEvaluation = firstMonth?.children.find(
					(k: Record<string, any>) => k.type === 'medicalEvaluation',
				);
				if (
					medicalEvaluation?.extra?.status === 'completed' ||
					medicalEvaluation?.extra?.status === 'scheduled'
				) {
					medicalEvaluationFilled = true;
				}
			}
		}

		await apiClient.patch(
			[
				'/health-plan',
				healthPlanUser?.healthPlanId,
				'user',
				healthPlanUser?.id,
				'item',
				activeHealthPlanUserItem?.id,
			].join('/'),
			{
				extra: {
					data: values,
				},
			},
		);

		if (medicalEvaluationFilled) return true;

		if (healthPlan.code === HealthPlanCode.BABY) {
			return true;
		}

		onSuccess?.();
		return false;
	};

	return {
		formScheme: form,
		submitValues,
	};
};

export default useHealthPlanOtherConsultationsForm;
